import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoadingService } from '@/core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUser } from '@/core/models/user';
import { UserService } from '@/core/services/open-api/user.service';
import { WizardService } from '../../services/wizard.service';
import { CrmWebhookEvent, CrmWebhookService } from '@/core/services/crm-webhook.service';
import { SelectOption } from '@/core/types/angular-primeng-api';
import { combineLatest, Subscription } from 'rxjs';

@Component({
    selector: 'app-wizard-second',
    templateUrl: './wizard-second.component.html',
    // styleUrls: ['./wizard-second.component.scss'],
    standalone: false,
})
export class WizardSecondComponent implements OnInit, OnDestroy {
    private me?: CurrentUser;
    firstName: string = '';
    lastName: string = '';
    companyName: string = '';
    companySizes: SelectOption[] = [];
    companySize?: SelectOption;
    companySectors: SelectOption[] = [];
    companySector?: SelectOption;
    subscriptions = new Subscription();

    constructor(
        private readonly crmWebhookService: CrmWebhookService,
        private readonly loadingService: LoadingService,
        private readonly translate: TranslateService,
        private userService: UserService,
        private wizardService: WizardService,
    ) {}

    ngOnInit(): void {
        this.loadingService.setLoading(true);

        this.subscriptions.add(
            combineLatest([
                this.userService.loadAccount(),
                this.userService.loadCurrentUser(),
                this.translate.get([
                    'companySizes_1',
                    'companySizes_2',
                    'companySizes_3',
                    'companySizes_4',
                    'companySizes_5',
                    'companySector_1',
                    'companySector_2',
                    'companySector_3',
                    'companySector_4',
                    'companySector_5',
                    'companySector_6',
                    'companySector_7',
                    'companySector_8',
                ]),
            ]).subscribe(([account, me, translations]) => {
                this.companyName = account?.accountSettings?.companyName ?? '';

                this.me = me;
                this.firstName = me.firstName;
                this.lastName = me.lastName;

                this.companySizes = [
                    { name: translations.companySizes_1, code: '1' },
                    { name: translations.companySizes_2, code: '2-10' },
                    { name: translations.companySizes_3, code: '11-50' },
                    { name: translations.companySizes_4, code: '51-200' },
                    { name: translations.companySizes_5, code: '201+' },
                ];
                this.companySectors = [
                    { name: translations.companySector_1, code: 'IT/ Web/ Media/ Design' },
                    { name: translations.companySector_2, code: 'Consulting/ Law firm' },
                    { name: translations.companySector_3, code: 'Engineering/ Architects' },
                    { name: translations.companySector_4, code: 'Industry' },
                    { name: translations.companySector_5, code: 'Handicraft' },
                    { name: translations.companySector_6, code: 'Tourism/ Real Estate' },
                    { name: translations.companySector_7, code: 'Non-profit' },
                    { name: translations.companySector_8, code: 'Other services' },
                ];

                this.loadingService.setLoading(false);
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    goToNext(): void {
        if (!this.companySector || !this.companySize) {
            return;
        }
        const accountSettings = {
            companyName: this.companyName,
            onboarding: '[true,false,false,false,false,false]',
        };

        this.userService.patchAccountSettings(accountSettings).subscribe(() => {
            void this.crmWebhookService.send(CrmWebhookEvent.updateProfile, {
                email: this.me?.email,
                company: this.companyName,
                first_name: this.firstName,
                last_name: this.lastName,
                company_size: this.companySize, //   this.companySize?.name
                sector: this.companySector, // this.companySector?.name
                cloud_account_id: this.me?.accountId,
            });

            if (!this.wizardService.isLastStep()) {
                this.wizardService.moveToNextStep();
            }
        });
    }
}
